import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import ApplicationTerm from '../ApplicationsTerm';

const General = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem label={'Traffic type'} field={'trafficType.name'} />
      <DescriptionItem
        label={'Networks'}
        field={'networks'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Platforms'}
        field={'platforms'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Applications'}
        field={'applicationInfo'}
        type={({ value }) => <ApplicationTerm data={value} />}
      />
      <DescriptionItem
        label={'Devices'}
        field={'devices'}
        placeholder={'All'}
        valueParser={'commaList'}
        lineClamp={16}
      />
      <DescriptionItem
        label={'OS'}
        placeholder={'All'}
        field={'osVersions'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Countries'}
        placeholder={'All'}
        field={'countryCodes'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Affiliates'}
        placeholder={'All'}
        field={'affiliates'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Include bots'}
        field={'isBotIncluded'}
        value={data?.isBotIncluded ? 'Yes' : 'No'}
      />
      <DescriptionItem
        label={'Purchase data'}
        field={'audienceTypes'}
        valueParser={'commaList'}
      />
    </DescriptionList>
  );
};

export default General;
